export default __webpack_public_path__ + "static/star-meshery-10118a491ba0e6e3a8210d541270e122.png";